import { DebugJson, DebugSection } from '../DebugSection';

export interface TwainStateSectionProps { searchTerm?: string }

export function TwainStateSection({ searchTerm }: TwainStateSectionProps): JSX.Element {
  const extra = (typeof window !== 'undefined' && window.__PCB_DEBUG_EXTRA__) || {};
  const twain = extra['twain'];

  return (
    <DebugSection
      id="twain"
      title="5. TWAIN / scanner bridge"
      searchTerm={searchTerm}
      defaultCollapsed={!twain}
    >
      {twain ? (
        <DebugJson value={twain} searchTerm={searchTerm} />
      ) : (
        <div className="pcb-debug-empty">
          Bridge state not yet registered. Components using <code>useTwainBridge()</code>
          should expose status via <code>window.__PCB_DEBUG_EXTRA__.twain</code> (status,
          sources, selectedSource, lastProbe, lastScan).
        </div>
      )}
    </DebugSection>
  );
}
